import { Reveal } from "./Reveal";
import { FAQS } from "../../config";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

export const Faq = () => (
  <section id="faq" data-testid="faq" className="relative z-10 py-24 sm:py-32 bg-[var(--surface)] border-t border-white/10">
    <div className="max-w-4xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline mb-3">Preguntas frecuentes</p>
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
          Resuelve tus dudas antes de agendar
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-10">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-${i}`} className="border-white/10">
              <AccordionTrigger className="text-left font-display font-medium text-lg hover:text-[var(--magenta)] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
